var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-bars"},[_c('div',{staticClass:"va-row"},[_c('div',{staticClass:"flex md12"},[_c('standard-bars')],1)]),_c('div',{staticClass:"va-row"},[_c('div',{staticClass:"flex md12"},[_c('colorful-bars')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }